import { lazy, Suspense } from 'react';

import { TextSkeleton } from '@/shared/components/skeletons';

/*
 * Components the module contributes to the shell and other pages (side panels, the profile tab), loaded on first use so
 * their forms and pickers stay out of the main bundle.
 */
const UserPanelLazy = lazy(async () => ({ default: (await import('./components/UserPanel')).UserPanel }));
const DepartmentPanelLazy = lazy(async () => ({
  default: (await import('./components/DepartmentPanel')).DepartmentPanel,
}));
const AboutTabLazy = lazy(async () => ({ default: (await import('./components/AboutTab')).AboutTab }));

const SecurityTabLazy = lazy(async () => ({
  default: (await import('./components/SecurityTab')).SecurityTab,
}));

export function SecurityTabEntry({ userId }: { userId: string }) {
  return (
    <Suspense fallback={<TextSkeleton lines={8} className="max-w-2xl" />}>
      <SecurityTabLazy userId={userId} />
    </Suspense>
  );
}

export function UserPanelEntry({ id }: { id: string }) {
  return (
    <Suspense fallback={<TextSkeleton lines={6} className="p-6" />}>
      <UserPanelLazy id={id} />
    </Suspense>
  );
}

export function DepartmentPanelEntry({ id }: { id: string }) {
  return (
    <Suspense fallback={<TextSkeleton lines={6} className="p-6" />}>
      <DepartmentPanelLazy id={id} />
    </Suspense>
  );
}

export function AboutTabEntry({ userId }: { userId: string }) {
  return (
    <Suspense fallback={<TextSkeleton lines={8} className="max-w-2xl" />}>
      <AboutTabLazy userId={userId} />
    </Suspense>
  );
}
